import { Component, computed, inject, input } from '@angular/core';
import { ProductCardComponent } from '../../../shared/product-card/product-card.component';
import { Location } from '@angular/common';
import { LocalStorageService } from '../../../shared/local-storage.service';
import { LOCALSTORAGE_KEYS } from '../../../shared/constants/databases';
import { Item } from '../../../shared/types/common.types';
import { Product } from '../../../product/product.types';
import { MatTab, MatTabGroup } from '@angular/material/tabs';

@Component({
    selector: 'app-subscriptions-signup',
    imports: [
        ProductCardComponent,
        MatTabGroup,
        MatTab
    ],
    templateUrl: './subscriptions-signup.component.html',
    styleUrl: './subscriptions-signup.component.scss'
})
export class SubscriptionsSignupComponent {

  //#region Services

  private location = inject(Location);

  private localStorageService = inject(LocalStorageService);

  //#endregion

  //#region Properties

  subscriptionCard = input.required<any[]>();

  selectedCard: any = null;

  categories = computed<(Item & { products: Product[] })[]>(() => this.#getCategories());

  //#endregion

  //#region Methods

  selectCard(card: any) {
    this.selectedCard = card;
  }

  continue() {
    this.localStorageService.set(LOCALSTORAGE_KEYS.FROM_SIGNUP, true);
    this.localStorageService.set(LOCALSTORAGE_KEYS.NEW_ACCOUNT, true);
    this.localStorageService.remove(LOCALSTORAGE_KEYS.SIGNUP_CUSTOM_BOX);
    this.location.replaceState('/shop');
    window.location.reload();
  }

  #getCategories() {

    if (!this.subscriptionCard().length)
      return [];

    const aux: (Item & { products: Product[] })[] = [];

    this.subscriptionCard()
      .forEach(x => {

        // Search the category

        let index = aux.findIndex(y => y.id === x.category.id);

        if (index === -1) {
          aux.push({
            id: x.category.id,
            name: x.category.name,
            products: []
          });

          index = aux.length - 1;
        }

        // Add the product

        aux[index].products.push(x);
      });

    return aux;
  }

  //#endregion
}
